<!--
 * @Author: hzm
 * @Date: 2022-07-07 15:48:41
 * @Description: 
-->

<template>
  <el-popover placement="bottom" :width="300" popper-class="msgpopper">
    <template #reference>
      <!-- <el-icon text="!gray-500 !20px">
                  <el-badge :value="allMsgCount === 0 ? void 0 : allMsgCount" class="item"><Bell /></el-badge
                ></el-icon> -->
      <el-badge class="!text-gary text-20px item leading-0" :value="allMsgCount === 0 ? void 0 : allMsgCount">
        <i class="el-icon-bell cursor-pointer"> </i>
      </el-badge>
    </template>
    <div>
      <div m="y-0 x-auto">
        <el-tabs v-model="curMsgTab" class="demo-tabs" :stretch="true">
          <el-tab-pane :label="`消息（${msgNotReadCount}）`" name="msg">
            <div>
              <transition-group v-if="msgNotReadList.length" name="list">
                <div
                  v-for="item in msgNotReadList"
                  :key="item.id"
                  class="pt-8px pb-4px px-8px border-0 border-b border-solid border-gray-200 hover:bg-gray-100 transform duration-75 cursor-pointer group"
                  @click="openMsgDialog(item)"
                >
                  <div class="!flex justify-between items-center">
                    <div class="!flex items-center w-full">
                      <div class="w-5px h-5px rounded-1 bg-blue-400 mr-4px"></div>
                      <span class="text-black text-12px w-90% font-600 line-clamp-1">{{ item?.title ?? '-' }}</span>
                    </div>
                    <span
                      class="text-green-500 text-12px hidden cursor-pointer group-hover:block w-59px"
                      @click="readMsg(item)"
                      >标记已读</span
                    >
                  </div>
                  <div class="leading-24px text-12px gary-400 pl-8px">
                    {{ item?.createTime ?? '-' }}
                  </div>
                </div>
              </transition-group>
              <div v-if="msgNotReadList.length" class="w-full h-46px leading-46px text-center">
                <div class="inline-block hover:text-blue w-1/2 cursor-pointer" @click="readAllMsg">清空通知</div>
                <div
                  class="inline-block box-border hover:text-blue w-1/2 cursor-pointer border-0 border-l border-solid border-gray-200 hover:text-blue"
                  @click="toUserCenter('msg')"
                >
                  查看更多
                </div>
              </div>
              <el-empty v-else :image-size="30" description="暂无信息" />
            </div>
            <MsgDialog
              :open.sync="msgDetailDialog.open"
              :content="msgDetailDialog.detail"
              :title="msgDetailDialog.title"
            >
            </MsgDialog>
          </el-tab-pane>
          <el-tab-pane :label="`待办（${taskNotHandelCount} ）`" name="Upcoming">
            <div v-if="taskNotHandelList.length">
              <div
                v-for="item in taskNotHandelList"
                :key="item.id"
                class="pt-8px pb-4px px-8px border-0 border-b border-solid border-gray-200 hover:bg-gray-100 transform duration-75 cursor-pointer group"
                @click="openTodoDialog(item)"
              >
                <div class="flex justify-between items-center">
                  <div class="!flex items-center w-full">
                    <div
                      class="w-5px h-5px rounded-1 bg-blue-400 mr-4px"
                      :style="`background:${getTaskColor(item)}`"
                    ></div>
                    <span class="text-black text-12px w-90% font-600">{{ item?.title ?? '-' }}</span>
                  </div>
                </div>
                <div class="leading-24px text-12px gary-400 pl-8px">
                  {{ item?.createTime ?? '-' }}
                </div>
              </div>
            </div>
            <div v-if="taskNotHandelList.length" class="w-full h-46px leading-46px text-center">
              <div class="inline-block hover:text-green-500 w-full cursor-pointer" @click="toUserCenter('todo')">
                查看更多
              </div>
            </div>
            <el-empty v-if="!taskNotHandelList.length" :image-size="30" description="暂无待办" />
            <TodoDialig
              :open.sync="todoDetailDialog.open"
              :content="todoDetailDialog.detail"
              :title="todoDetailDialog.title"
            >
            </TodoDialig>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-popover>
</template>

<script setup lang="ts" name="MessagePopover">
import MsgDialog from '@/views/components/msgDialog.vue';
import TodoDialig from '@/views/components/todoDialig.vue';
import useMsgDialog from '@/composables/useMsgDialog';
import useTodoDialog from '@/composables/useTodoDialog';
import { useMessageStore } from '@/stores/message';
import { useTaskStore } from '@/stores/todoTask';
const visible = ref(true);
const curMsgTab = ref('msg');
const props = defineProps({
  userCenterUrl: {
    type: String,
  },
});

const store = useMessageStore();
const taskStore = useTaskStore();
const router = useRouter();
const msgNotReadCount = computed(() => {
  return store.msgNotReadCount ?? '...';
});
const msgNotReadList = computed(() => {
  return store.msgNotReadList ?? [];
});

const taskNotHandelCount = computed(() => {
  return taskStore.taskNotHandelCount ?? '...';
});
const taskNotHandelList = computed(() => {
  return taskStore.taskNotHandelList ?? [];
});

const allMsgCount = computed(() => {
  return taskNotHandelCount.value + msgNotReadCount.value;
});

const platInfo = computed(() => {
  const route = useRoute();
  const homePath = route.path.split('/')?.[1] ?? '';
  return homePath == 'shopplat' ? 'merchant' : 'enterprise_console';
});

const { openMsgDialog, readMsg, msgDetailDialog } = useMsgDialog();
const { openMsgDialog: openTodoDialog, todoDetailDialog } = useTodoDialog();
store.getUserNotReadMsgList({
  usePlatform: platInfo.value,
});
taskStore.getUserNotHandelTaskList({
  usePlatform: platInfo.value,
});
// store.dispatch('getUserNotReadMsgList');
// store.dispatch('getUserNotHandelTaskList');
// query tab=1 代表消息 2 代表待办

function toUserCenter(tab) {
  if (tab == 'msg') {
    router.push(props.userCenterUrl + '?tab=2');
  } else {
    router.push(props.userCenterUrl + '?tab=3');
  }
}

function getTaskColor(row: API.TodoTask) {
  if (Number(row.expireFlag) == 1) {
    return 'var(--el-color-danger)';
  }

  if (row.status == 0) {
    return 'var(--el-color-primary)';
  }
  if (row.status == 1) {
    return 'var(--el-color-warning)';
  }
}

function readAllMsg() {
  modal.confirm('是否标记所有消息为已读').then(() => {
    store.readAllMsg().then(() => {
      store.getUserNotReadMsgList({ usePlatform: platInfo.value, });
    });
    // store.dispatch('readAllMsg').then(() => {
    //   store.dispatch('getUserNotReadMsgList');
    // });
  });
}
</script>

<style lang="scss">
// .msgpopper {
//   &.el-popper {
//     padding: 0 !important;
//   }
// }
.list-move,
/* 对移动中的元素应用的过渡 */
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* 确保将离开的元素从布局流中删除
  以便能够正确地计算移动的动画。 */
.list-leave-active {
  position: absolute;
}
</style>
